@if (isVisible && isFofBruger) {
<div class="servicepro-app-referrer" [@slideAnimation] role="banner" aria-label="ServicePro app reklame">
    <div class="servicepro-app-referrer__container">
        <div class="servicepro-app-referrer__info">
            <button class="servicepro-app-referrer__close" (click)="close()" aria-label="Luk ServicePro app-promovering" type="button">✕</button>
            <img class="servicepro-app-referrer__icon" src="/dist/e-forsyning/assets/icon-servicepro.png" alt="ServicePro app ikon" width="48" height="48" />
            <div class="servicepro-app-referrer__content">
                <h2 class="servicepro-app-referrer__title">Hent ServicePro appen</h2>
                <p class="servicepro-app-referrer__subtitle">Få adgang til teknikerfunktionerne direkte i appen</p>
            </div>
        </div>
        <button class="servicepro-app-referrer__open-app" (click)="openApp()" aria-label="Åben ServicePro app eller gå til app store" type="button">Åben</button>
    </div>
</div>
}
